import { DatePipe } from '@angular/common';
import { ApiResponse } from './apiresponse';

export class ReligiousInfoVO {
    id: number;
    personId: number;
    consecratedLifeType: ConsecratedLifeTypeVO;
    houseName: HouseNameVO;
    community: CommunityVO;
    localSuperior: LocalSuperiorVO;
    majorSuperior: MajorSuperiorVO;
    livingArrangement: string;
    statusInDioceses :StatusInDiocesesVO;
    status: StatusVO;
    deceasedDate: string;
    ageRange: string;
    notes: string;
    vocationalContact: string;
    localSuperiorAssignment: string;
    website: string;
    assignment: string;
    firstProfessionStartDate: string;
    finalProfession: string;
    isActive: string;
    createdBy: string;
    createdTime: Date;
    lastUpdatedBy: string;
    lastUpdatedTime: Date;
}
export class ConsecratedPersonResponse {
    apiResponseVO: ApiResponse;
    religiousInfoVOList: Array<ReligiousInfoVO>;
    bytes: string;

}
export class SearchVO {
    firstName: string;
    lastName: string;
    dob: Date;
    communityNumber: number;
    isActive: string;
    pageNo: number;
    pageSize: number;
    username: string;
    status: string;
    city: string;
    zipCode: string;
}

export class HouseVO {
    id: number;
    houseName: string;
    address: string;
    state: string;
    city: string;
    zip: string;
    isActive: string;
    zipExtn: number;
    createdBy: string;
    createdTime: Date;
    lastUpdatedBy: string;
    lastUpdatedTime: Date;
}
export class HouseNameVO {
    id: number;
    houseName: string;
    address: string;
    state: string;
    city: string;
    zip: string;
    isActive: string;
    zipExtn: number;
    createdBy: string;
    createdTime: Date;
    lastUpdatedBy: string;
    lastUpdatedTime: Date;
}
export class CommunityVO {
    id: number;
    community: string;
    communityCode: string;
    isActive: string;
    createdBy: string;
    createdTime: Date;
    lastUpdatedBy: string;
    lastUpdatedTime: Date;
}
export class LocalSuperiorVO {
    id: number;
    name: string;
    email: string;
    isActive: string;
    phone: string;
    phoneExtn: string;
    createdBy: string;
    createdTime: Date;
    lastUpdatedBy: string;
    lastUpdatedTime: Date;
}
export class ConsecratedLifeTypeVO {
    id: number;
    consecratedLifeType: string;
    createdBy: string;
    createdTime: Date;
    lastUpdatedBy: string;
    lastUpdatedTime: Date;
}
export class MajorSuperiorVO {
    id: number;
    name: string;
    email: string;
    isActive: string;
    createdBy: string;
    createdTime: Date;
    lastUpdatedBy: string;
    lastUpdatedTime: Date;
}


export class SearchResponse {
    apiResponseVO: ApiResponse;
    searchResponseVOList: SearchResponseVO[];
}

export class SearchResponseVO {
    id: number;
    firstName: string;
    lastName: string;
    dob: Date;
    communityName: string;
    address: string;
    city: string;
    email: string;
    isActive: string;
    sufix: string;
    mobilePhone: string;
    homePhone: string;
    workPhone: string;
    status: string;
    localSuperior: string;
    majorSuperior: string;
}

export class HouseNameSearchVO {

    houseName: string;
    isActive: string;
    pageNo: number;
    pageSize: number;
}
export class HouseNameResponse {
    apiResponseVO: ApiResponse;
    houseNameVOList: HouseVO[];
    totalNumberOfRecords: number;

}
export class StatusVO {
    id: number;
    status: string;
    description: string;
    createdBy: string;
    createdTime: Date;
    lastUpdatedBy: string;
    lastUpdatedTime: Date;
}
export class StatusInDiocesesVO {
    id: number;
    statusInDioceses: string;
    createdBy: string;
    createdTime: Date;
    lastUpdatedBy: string;
    lastUpdatedTime: Date;
}
